import { render, staticRenderFns } from "./ExpotPopup.vue?vue&type=template&id=2df3a8a0&scoped=true&"
import script from "./ExpotPopup.vue?vue&type=script&lang=js&"
export * from "./ExpotPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExpotPopup.vue?vue&type=style&index=0&id=2df3a8a0&prod&lang=scss&scoped=true&"
import style1 from "./ExpotPopup.vue?vue&type=style&index=1&id=2df3a8a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3a8a0",
  null
  
)

export default component.exports